import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const mxn = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    const str = String(s);
    // Fechas sin hora (YYYY-MM-DD) se construyen en zona local para evitar el corrimiento
    // de un día que provoca new Date() al interpretarlas como UTC.
    const m = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(str);
    return new Intl.DateTimeFormat("es-MX", { day: "2-digit", month: "short", year: "numeric" }).format(d);
  } catch {
    return s;
  }
};

export async function exportToExcel(filename, sheet, headers, rows, summary) {
  const payload = { filename, sheet, headers, rows };
  if (summary && summary.rows && summary.rows.length) {
    payload.summary_title = summary.title || "Resumen";
    payload.summary_headers = summary.headers || [];
    payload.summary_rows = summary.rows;
  }
  const res = await api.post("/export/xlsx", payload, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
